import { UploadSyncResource } from "@gx/ts-contracts/services/uploader/resources/uploader_pb";

import { CreateSourceFileUploadPhase } from "@/pages/sources/components/create/sources/file-upload/types";
import type { FileUploadProgress } from "@/pages/sources/components/create/sources/types";

export enum CreateSourceFileUploadActionType {
  SET_SOURCE_NAME = "SET_SOURCE_NAME",
  ADD_FILES = "ADD_FILES",
  REMOVE_FILE = "REMOVE_FILE",
  CLEAR_FILES = "CLEAR_FILES",
  SET_PHASE = "SET_PHASE",
  SET_SESSION = "SET_SESSION",
  SET_ERROR = "SET_ERROR",
  INIT_FILE_PROGRESS = "INIT_FILE_PROGRESS",
  UPDATE_FILE_PROGRESS = "UPDATE_FILE_PROGRESS",
  SET_OVERALL_PROGRESS = "SET_OVERALL_PROGRESS",
  SET_SHOULD_SHOW_ERRORS = "SET_SHOULD_SHOW_ERRORS",
}

export interface SetSourceNameAction {
  type: CreateSourceFileUploadActionType.SET_SOURCE_NAME;
  payload: string;
}

export interface AddFilesAction {
  type: CreateSourceFileUploadActionType.ADD_FILES;
  payload: File[];
}

export interface RemoveFileAction {
  type: CreateSourceFileUploadActionType.REMOVE_FILE;
  payload: number;
}

export interface ClearFilesAction {
  type: CreateSourceFileUploadActionType.CLEAR_FILES;
}

export interface SetPhaseAction {
  type: CreateSourceFileUploadActionType.SET_PHASE;
  payload: CreateSourceFileUploadPhase;
}

export interface SetSessionAction {
  type: CreateSourceFileUploadActionType.SET_SESSION;
  payload: UploadSyncResource;
}

export interface SetErrorAction {
  type: CreateSourceFileUploadActionType.SET_ERROR;
  payload: string | null;
}

export interface InitFileProgressAction {
  type: CreateSourceFileUploadActionType.INIT_FILE_PROGRESS;
  payload: Map<string, FileUploadProgress>;
}

export interface UpdateFileProgressAction {
  type: CreateSourceFileUploadActionType.UPDATE_FILE_PROGRESS;
  payload: {
    fileId: string;
    updates: Partial<FileUploadProgress>;
  };
}

export interface SetOverallProgressAction {
  type: CreateSourceFileUploadActionType.SET_OVERALL_PROGRESS;
  payload: number;
}

export interface SetShouldShowErrorsAction {
  type: CreateSourceFileUploadActionType.SET_SHOULD_SHOW_ERRORS;
  payload: boolean;
}

export type CreateSourceFileUploadAction =
  | SetSourceNameAction
  | AddFilesAction
  | RemoveFileAction
  | ClearFilesAction
  | SetPhaseAction
  | SetSessionAction
  | SetErrorAction
  | InitFileProgressAction
  | UpdateFileProgressAction
  | SetOverallProgressAction
  | SetShouldShowErrorsAction;
